import { useCallback, useEffect, useState } from 'react';
import { WPSearchResultItem } from '../../typings';
import { SingleJobRow } from '../SingleJobRow/SingleJobRow';
import * as styles from './SimilarOpportunities.module.scss';
import { searchPosts } from '../../services/common.service';

const { __ } = window.wp.i18n;

// get the filters selected in settings
interface Window {
  cg_jobs_es_var?: { pathName ?: string};
  cg_jobs_country_code?: string;
}
const countryCodeinSettings = (window as Window).cg_jobs_country_code;
const cCode = countryCodeinSettings ? countryCodeinSettings : (window as Window).cg_jobs_es_var?.pathName;

interface SimilarOpportunitiesProps {
  id?: string;
  keyword?: string;
  professionalCommunity?: string;
  contractType?: string;
  experienceLevel?: string;
}

interface currentJobFiltersProps {
  id?: string;
  professional_communities?: string,
  contract_type?: string,
  experience_level?: string
}

export const SimilarOpportunities: React.FC<SimilarOpportunitiesProps> = (props) => {
  const [jobList, setJobList] = useState<WPSearchResultItem[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalJobs, setTotalJobs] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(5);
  const [showMobile, setShowMobile] = useState<boolean>();

  useEffect(() => {     
    fetchListings(); 
  }, [perPage])
  
  //Show mobile 
  useEffect(() => {
    const showFilters = () => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            setShowMobile(false);
            setPerPage(5);
        } else {
            setShowMobile(true);
            setPerPage(4); 
        }
    };

    // Set the initial placeholder
    showFilters();  
    // Add an event listener for window resize
    window.addEventListener('resize', showFilters);  
    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', showFilters);
  }, []);

  const fetchListings = async () => {  
    const currentJobFilters = {
      id: props.id,
      professional_communities: props.professionalCommunity,
      contract_type: props.contractType,
      experience_level: props.experienceLevel
    }

    const fetchFilteredPosts = (filters: currentJobFiltersProps) => {
      return searchPosts({
        size: perPage,
        page: currentPage,
        country_code: cCode,
        filters,
      }).then(data => {
        const filteredData = data.data.filter(job => job.id !== props.id);
        return { filteredData, total: filteredData.length };
      });
    };
    
    fetchFilteredPosts(currentJobFilters)
      .then(({ filteredData, total }) => {
        if (total < 3) {
          return fetchFilteredPosts({ professional_communities: props.professionalCommunity });
        }
        return { filteredData, total };
      })
      .then(({ filteredData, total }) => {
        if (total < 3) {
          return fetchFilteredPosts({});
        }
        return { filteredData, total };
      })
      .then(({ filteredData }) => {
        setJobList(filteredData);
        setTotalJobs(filteredData.length);
      })
      .catch(error => {
        console.error('Error fetching listings:', error);
      });
    

  };
 
  return (   
    <>
    {totalJobs > 0 && 
      <div className={styles['similar-section']}>
        <div className={[styles['similar-wrapper'], 'container'].join(' ')}>
          <div className={styles['similar-header']}>
          <h2>{ showMobile ? `${ __( 'Similar Jobs', 'cg-jobs' ) }` : `${ __( 'Similar job opportunities', 'cg-jobs' ) }`}</h2>
            {!showMobile  && <div>{ __( "If this job isn't the right fit for you, explore other opportunities!", 'cg-jobs' ) }</div>}
            
          </div>
          <ul className={styles['similar-job-list']} id="similar-jobs"> 
            {jobList.map((job:WPSearchResultItem, index) => (
              (index < 3 ) ? <SingleJobRow key={job.id} refId={job.ref ?? ""} source={job.source} id={job.id} title={job.title} location={job.location} sbu={job.sbu} contract_type={job.contract_type} experience_level={job.experience_level} department={job.department} professional_communities={job.professional_communities}/> : ''
            ))}     
          </ul> 
        </div>
    </div> }
  </>
  )
}